import blomstereng from "../assets/images/blomstereng.png";
// @ts-ignore: CSS module import without type declarations
import "./Home.css";
import Countdown from "../components/countdown";
const flowerStyle = {
  maxWidth: "350px",
  maxHeight: "250px",
  width: "auto",
  height: "auto",
  marginLeft: "-40px", // 🔑 overlap
};

export default function Home() {
  return (
    <section className="home_page">
      {/* Centered text */}
      <h1 className="home_title">
        Erik og Jorid
      </h1>

      <p className="home_paragraph">
        Vi sier JA til hverandre om
      </p>

      <div className="home_countdown">
        <Countdown targetDate="2027-07-18T12:30:00" />
      </div>

      {/* Bottom flower row */}
      <div className="home_flowers">
        {Array.from({ length: Math.ceil(window.innerWidth / 250) }).map((_, i) => (
          <img
            key={i}
            src={blomstereng}
            alt=""
            style={flowerStyle}
          />
        ))}
      </div>
    </section>
  );
}
